export function isTruthy (value: any) {
  return (
    typeof value === 'string'
      ? (value.toLowerCase() === 'true' || value.toLowerCase() === '1' || value.toLowerCase() === 'yes' || value.toLowerCase() === 'on')
      : !!value
  );
}
